import React from 'react';
import { Library, BookOpen, Database } from 'lucide-react';
export function LibrarySection() {
  return <section className="pb-24 px-6 md:px-12 lg:px-24 bg-[#F8F8F8]" style={{
    marginTop: '-4rem',
    paddingTop: '7rem'
  }} data-id="element-841">
      <div className="max-w-7xl mx-auto" data-id="element-842">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-843">
          <span className="text-sm font-bold tracking-widest uppercase text-[#0066FF] mb-4 block font-sans" data-id="element-844">
            Your Sovereign IP
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 font-['Syne']" data-id="element-845">
            The Library of <br data-id="element-846" />
            Enterprise Intelligence
          </h2>
          <p className="text-xl text-gray-600 font-light" data-id="element-847">
  Don't just store data;{' '}
  <strong className="text-black font-medium" data-id="element-848">
    compile Intelligence
  </strong>
  . Distill your policies, expert judgment, and professional
  standards into a library of machine-readable behavioral attributes (rules).
  It's not a cost center, it's an{' '}
  <strong className="text-black font-medium" data-id="element-849">
    asset class
  </strong>
  .
        </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-850">
          <div className="bg-white p-8 rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-851">
            <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center mb-6" data-id="element-852">
              <Library className="w-6 h-6 text-[#0066FF]" data-id="element-853" />
            </div>
            <h3 className="text-xl font-bold mb-4 font-['Syne']" data-id="element-854">
              Central Authority
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-855">
              The single source of truth for how your business 'thinks,'
              independent of any single AI vendor or model provider.
            </p>
          </div>

          <div className="bg-white p-8 rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden" data-id="element-856">
            <div className="absolute top-0 right-0 w-24 h-24 bg-[#FFE066] opacity-10 rounded-bl-full" data-id="element-857"></div>
            <div className="w-12 h-12 bg-yellow-50 rounded-full flex items-center justify-center mb-6 relative z-10" data-id="element-858">
              <BookOpen className="w-6 h-6 text-yellow-600" data-id="element-859" />
            </div>
            <h3 className="text-xl font-bold mb-4 font-['Syne'] relative z-10" data-id="element-860">
              Machine-Readable
            </h3>
            <p className="text-gray-600 leading-relaxed relative z-10" data-id="element-861">
              Policies broken down into atomic, composable instructions
              (attributes) that can be activated in real-time.
            </p>
          </div>

          <div className="bg-white p-8 rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-862">
            <div className="w-12 h-12 bg-purple-50 rounded-full flex items-center justify-center mb-6" data-id="element-863">
              <Database className="w-6 h-6 text-purple-600" data-id="element-864" />
            </div>
            <h3 className="text-xl font-bold mb-4 font-['Syne']" data-id="element-865">
              Asset Appreciation
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-866">
              Your intelligence library goes with you. It's your asset, and it
              appreciates over time as you refine your logic.
            </p>
          </div>
        </div>
      </div>
    </section>;
}